module.exports = __webpack_public_path__ + "img/evaluate-no.85fc2a3a.png";